import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZero = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.995 16.973C11.0446 16.973 10.2862 16.5602 9.71978 15.7346C9.16298 14.909 8.88458 13.7234 8.88458 12.1778C8.88458 10.6322 9.16298 9.46099 9.71978 8.66419C10.2862 7.86739 11.0446 7.46899 11.995 7.46899C12.9454 7.46899 13.699 7.86739 14.2558 8.66419C14.8222 9.46099 15.1054 10.6322 15.1054 12.1778C15.1054 13.7234 14.8222 14.909 14.2558 15.7346C13.699 16.5602 12.9454 16.973 11.995 16.973ZM11.995 15.677C12.2926 15.677 12.5566 15.5666 12.787 15.3458C13.0174 15.1154 13.195 14.7458 13.3198 14.237C13.4542 13.7282 13.5214 13.0418 13.5214 12.1778C13.5214 11.3138 13.4542 10.6322 13.3198 10.133C13.195 9.63379 13.0174 9.28339 12.787 9.08179C12.5566 8.87059 12.2926 8.76499 11.995 8.76499C11.707 8.76499 11.4478 8.87059 11.2174 9.08179C10.987 9.28339 10.8046 9.63379 10.6702 10.133C10.5358 10.6322 10.4686 11.3138 10.4686 12.1778C10.4686 13.0418 10.5358 13.7282 10.6702 14.237C10.8046 14.7458 10.987 15.1154 11.2174 15.3458C11.4478 15.5666 11.707 15.677 11.995 15.677Z",
		fill: "currentcolor"
	})]
});
export default SvgZero;
